module.exports = __webpack_public_path__ + "static/media/screenshot.eb87a544.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/screenshot.svg
// module id = 931
// module chunks = 7